export default <T extends Function>(cb: T, wait: number) => {
    let h = 0;
    const callable = (...args: any) => {
        clearTimeout(h);
        h = window.setTimeout(() => cb(...args), wait);
    };
    return <T>(<any>callable);
};
